module.exports = __webpack_public_path__ + "static/img/partnerTwo.49c3504.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/partnerTwo.jpg
// module id = h61w
// module chunks = 1